import { useEffect } from 'react';

import {
  clearSentryUser,
  setSentryFeatureFlags,
  type SentryIdentity,
  setSentryUser,
} from 'utils/sentryUser';

type Whoami = SentryIdentity & {
  feature_flags?: Record<string, boolean | undefined>;
};

/**
 * Keep the Sentry scope in step with who is signed in.
 *
 * An effect rather than a one-shot call at boot: account switching and
 * impersonation both replace the identity without remounting the tree, and a
 * stale id would credit the wrong person with the next error.
 */
export function useSentryIdentify(whoami: Whoami | undefined | null): void {
  useEffect(() => {
    if (!whoami?.external_id) {
      clearSentryUser();
      return;
    }

    setSentryUser(whoami);
    setSentryFeatureFlags(whoami.feature_flags);
  }, [whoami]);
}
